import { render } from "./BatchPrintOrders.vue?vue&type=template&id=707c39e8&scoped=true"
import script from "./BatchPrintOrders.vue?vue&type=script&lang=js"
export * from "./BatchPrintOrders.vue?vue&type=script&lang=js"

import "./BatchPrintOrders.vue?vue&type=style&index=0&id=707c39e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707c39e8"]])

export default __exports__